<div class="slideshow-wrapper">
  <div style="width: 100%; margin-bottom: 30px">
    <div
      class="current-content-wrapper"
      [@blur]="transitionState"
      (@blur.done)="transitionState = true"
    >
      <ng-content></ng-content>
    </div>
  </div>

  <div class="radio-wrapper" *ngIf="inputArray.length > 1">
    <div class="radio-step">
      <mat-icon
        (click)="navigateLeft()"
        [ngStyle]="{
          color:
            currentElement <= 0 ? 'rgba(0, 0, 0, 0.26)' : 'rgba(0, 0, 0, 1)'
        }"
      >
        keyboard_arrow_left
      </mat-icon>

      <app-stepper-radio
        [radioSteps]="stepperIds"
        [initStep]="currentElement"
        [showStepNo]="false"
        [disableButtons]="true"
      >
      </app-stepper-radio>

      <mat-icon
        mat-icon-button
        (click)="navigateRight()"
        [ngStyle]="{
          color:
            currentElement >= inputArray.length - 1
              ? 'rgba(0, 0, 0, 0.26)'
              : 'rgba(0, 0, 0, 1)'
        }"
      >
        keyboard_arrow_right
      </mat-icon>
    </div>
  </div>
</div>
